export default function SwitchAdmin({ id, label, checked, onChange, disabled = false }) {
  return (
    <div className="flex items-center justify-between gap-4">
      <span className="text-sm text-zi-text-light dark:text-zi-text-dark">{label}</span>
      <button
        id={id}
        type="button"
        role="switch"
        aria-checked={checked}
        disabled={disabled}
        onClick={() => onChange(!checked)}
        className={`relative inline-flex h-6 w-11 shrink-0 rounded-full transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#2878A3] focus-visible:ring-offset-2 disabled:opacity-50 ${checked ? "bg-[#2878A3]" : "bg-[#9CA3AF] dark:bg-[#4B5563]"}`}
      >
        <span className={`absolute left-1 top-1 size-4 rounded-full bg-white shadow transition-transform ${checked ? "translate-x-5" : "translate-x-0"}`} />
      </button>
    </div>
  );
}
